var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { StyledFlex } from '../../subcomponents';
export var StyledError = styled(StyledFlex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: ", ";\n"], ["\n  padding-top: ", ";\n"])), function (props) { return (props.mobile ? '48px;' : '56px;'); });
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map